import { LanguageActionTypes } from '../../actions/user/language.actions';
import localStorageFacade, { LocalStorageKeys } from '../../../utils/localStorageFacade';

export default (state = {
  value: localStorageFacade.get(LocalStorageKeys.LANGUAGE) || 'en', selectedByUser: false,
}, { type, payload }) => {
  switch (type) {
    case LanguageActionTypes.SET_LANGUAGE:
      return {
        value: payload.lng,
        selectedByUser: true,
      };
    default:
      return state;
  }
};
